import React, { createContext, PureComponent } from 'react';
import { IApplePayConfigurationContext } from '../types/applepay/ApplePayConfigurationContext';
import { ApplePayConfiguration } from '../types/applepay/ApplePayConfiguration';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  applePayConfiguration: undefined,
  isApplePayScriptLoaded: false,
};

export const ApplePayConfigurationContext = createContext<Partial<IApplePayConfigurationContext>>(initialValue);

export class ApplePayConfigurationContextProvider extends PureComponent<
  IProps,
  Partial<IApplePayConfigurationContext>
> {
  constructor(props) {
    super(props);
    this.state = {
      applePayConfiguration: undefined,
      isApplePayScriptLoaded: false,
    };
  }

  setApplePayConfiguration = (applePayConfiguration: ApplePayConfiguration) => {
    this.setState({ applePayConfiguration });
  };

  setIsApplePayScriptLoaded = (isApplePayScriptLoaded: boolean) => {
    this.setState({ isApplePayScriptLoaded });
  };

  render() {
    const { Provider } = ApplePayConfigurationContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setApplePayConfiguration: this.setApplePayConfiguration,
          setIsApplePayScriptLoaded: this.setIsApplePayScriptLoaded,
        }}
      >
        {children}
      </Provider>
    );
  }
}
